import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../../i18n.js";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../../App.js";
import "../../../css/wallet/Token/DepositToken.css";
import { tomanDepostRequest } from "./TomanDepositRequest.js";

function TomanDeposit({ theme, setDepositStatus, token, data }) {
  const [tomanDepositAmountInput, setTomanDepositAmountInput] = useState("");
  const [tomanDepositReceiptInput, setTomanDepositReceiptInput] = useState("");
  const [tomanDepositDateInput, setTomanDepositDateInput] = useState("");

  const isFilled = tomanDepositAmountInput && tomanDepositReceiptInput;

  const [tomanDepositButtonStatus, setTomanDepositButtonStatus] =
    useState(false);

  const [copyStatus, setCopyStatus] = useState(false);

  const translationSession = sessionStorage.getItem("translation");
  const { t, i18n } = useTranslation();

  const [active, setActive] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (translationSession) {
      i18n.changeLanguage(translationSession);
    } 

    setActive(true);
  }, [translationSession, i18n]);

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setDepositStatus(false);
            setTomanDepositAmountInput("");
            setTomanDepositReceiptInput("");
          }, 150);
        }}
      ></div>
      <div className={`depositPopupDiv ${theme} ${active && "active"}`}>
        <div className={`depositHeader ${theme}`}>
          {t("Deposit")} {token.toUpperCase()}
        </div>

        <div className="depositContentDiv">
          <div className="cardNumberDiv">
            <div className={`dfghtbvfd ${theme}`}>{data[1].bank_card}</div>

            <button
              className="tiny_button"
              onClick={() => {
                setCopyStatus(true);
                navigator.clipboard.writeText(data[1].bank_card);

                setTimeout(() => {
                  setCopyStatus(false);
                }, 1500);
              }}
            >
              {copyStatus ? (
                <img src="/icons/tick.png" className={`icon ${theme}`}></img>
              ) : (
                <img src="/icons/copy.png" className={`icon ${theme}`}></img>
              )}
            </button>
          </div>

          <div className="inputsDivfromDeposit">
            <div className="inputDivfromDeposit">
              <div>{t("Amount")}</div>
              <input
                className={`input dir_ltr ${theme}`}
                type="text"
                onChange={(e) => {
                  setTomanDepositAmountInput(e.target.value);
                }}
              ></input>
            </div>

            <div className="inputDivfromDeposit">
              <div>{t("Deposit receipt")}</div>
              <input
                className={`input dir_ltr ${theme}`}
                type="text"
                onChange={(e) => {
                  setTomanDepositReceiptInput(e.target.value);
                }}
              ></input>
            </div>

            <div className="inputDivfromDeposit">
              <div>{t("Deposit date")}</div>
              <input
                className={`input dir_ltr ${theme}`}
                type="text"
                onChange={(e) => {
                  setTomanDepositDateInput(e.target.value);
                }}
              ></input>
            </div>

          </div>

          <button
            className={`submit_button ${theme} ${isFilled ? "active" : theme}`}
            onClick={() => {
              if (isFilled) {
                tomanDepostRequest(
                  tomanDepositAmountInput,
                  tomanDepositReceiptInput,
                  tomanDepositDateInput,
                  setTomanDepositButtonStatus,
                  navigate,
                );
              }
            }}
          >
            {tomanDepositButtonStatus ? (
              <img src="/icons/loading.png" className={`rotate`}></img>
            ) : (
              t("Submit")
            )}
          </button>
        </div>
      </div>
    </>
  );
}

export default TomanDeposit;
